import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import { reactSelectStyles } from '../helpers/utils.js';

class StateFilter extends Component {
    state = {
        stateLists: [],
        stateValue: this.props.selected_state,
        isStateLoading: true
    };

    componentDidMount() {
        this.getState();
    }

    resetStateFilter() {
        this.setState({
            stateValue: { value: '', label: 'All' },
        })
    }

    getState() {
        axios.get(config.get('API_URL') + '/filters/get-all-states/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if (Array.isArray(response.data) && response.data.length) {
                const newStates = response.data.map(state => ({
                    value: state.state_name,
                    label: state.state_name
                }));
                this.setState(prev => ({
                    stateLists: [...prev.stateLists, ...newStates],
                    isStateLoading: false
                }));
            } else {
                this.setState({ isStateLoading: false });
            }
        });
    }

    changeState(optionSelected) {
        const tenderArray = optionSelected ? [optionSelected.value] : [];
        this.props.onSelectstate(optionSelected, tenderArray);
        this.setState({
            stateValue: optionSelected || { value: '', label: 'All' },
        });
    }

    render() {
        return (
            <Select
                name="state"
                value={this.state.stateValue}
                styles={reactSelectStyles}
                className="report-listbox"
                isClearable={false}
                onChange={this.changeState.bind(this)}
                options={this.state.stateLists}
                isLoading={this.state.isStateLoading}
                placeholder="[Select State]"
            />
        );
    }
}

export default StateFilter;
